import { createSlice} from '@reduxjs/toolkit';
import { RootState } from '..';

export interface parkingCategoryState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: parkingCategoryState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const parkingCategorySlice = createSlice({
  name: ' parkingCategory',
  initialState,
  reducers: {
    setParkingCategory: (state: any, action: any) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewParkingCategory: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setParkingCategory, addNewParkingCategory, reset } = parkingCategorySlice.actions;
export const getParkingCategory = (state: RootState) => state.parkingCategory.data;
export const addParkingCategory = (state: RootState) => state.parkingCategory.data;
export const getParkingCategoryTotalRecord = (state: RootState) => state.parkingCategory.totalRecords;
export default parkingCategorySlice.reducer;
